import React, { createContext, useState, useEffect, useContext } from "react";
import { isTokenExpired } from "../utils/expiredToken";
import AuthService from "../services/AuthService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [userRole, setUserRole] = useState(null); // Add userRole state

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUserDetails = localStorage.getItem("userDetails"); // Changed variable name to avoid shadowing
    if (token && !isTokenExpired(token)) {
      const parsedUserDetails = AuthService.ensureParsed(storedUserDetails); // Use storedUserDetails
      if (parsedUserDetails) {
        // Ensure parsedUserDetails is not null before accessing properties
        const role = parsedUserDetails.user_role;
        setUserRole(role); // Set userRole
        const isAdmin = role === "Admin" || role === "Admin"; // Use role variable
        setIsAdminUser(isAdmin);
        setIsAuthenticated(true);
        setUserDetails(parsedUserDetails); // Use parsedUserDetails object
      } else {
        logout(); // Logout if parsing fails
      }
    } else {
      logout();
    }
    setIsLoading(false);
  }, []);

  const login = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("userDetails", JSON.stringify(user));
    setIsAuthenticated(true);
    setUserDetails(user);
    setUserRole(user.user_role); // Set userRole on login
    const isAdmin = user.user_role === "Admin" || user.user_role === "Admin";
    setIsAdminUser(isAdmin); // Update isAdminUser on login
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userDetails");
    setIsAuthenticated(false);
    setUserDetails(null);
    setUserRole(null); // Reset userRole on logout
    setIsAdminUser(false); // Reset isAdminUser on logout - good practice for clarity
  };

  const updateUserDetails = (user) => {
    setUserDetails(user);
  }
  
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        userDetails,
        login,
        logout,
        isAdminUser,
        userRole,
        updateUserDetails,
      }} // Include userRole in context value
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
